import { COLORING_BOOK_IMAGES } from '../../constants/coloringBook'
import './ImagePicker.css'

interface ImagePickerProps {
  onPick: (path: string) => void
  onClose: () => void
}

export function ImagePicker({ onPick, onClose }: ImagePickerProps) {
  return (
    <section className="image-picker" aria-label="Pick a picture">
      <header className="image-picker-head">
        <h2>Pick a picture</h2>
        <button type="button" className="image-picker-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      </header>
      <div className="image-picker-grid">
        {COLORING_BOOK_IMAGES.map((img) => (
          <button
            key={img.id}
            type="button"
            className="image-picker-card"
            onClick={() => onPick(img.path)}
            aria-label={img.name}
          >
            <img src={img.path} alt="" width={160} height={160} />
            <span>{img.name}</span>
          </button>
        ))}
      </div>
    </section>
  )
}
